/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://jrkwhanqd5fanln4prcjcrq374.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-kju3eqpsg5bcniugqjmcf7skrm",
    "aws_cognito_identity_pool_id": "us-east-1:7e5d9feb-016f-459c-8b8a-96886aaaebdb",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_xQyuoOU6G",
    "aws_user_pools_web_client_id": "2l6jjqq24vb8g0kfh4tgl98o5e",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "source-data-hosting-bf-developmc",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1d5yk44gapx1q.cloudfront.net",
    "aws_user_files_s3_bucket": "source-data-docs-bf-developmc",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "maps": {
                "items": {
                    "map1a7a4144-developmc": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "map1a7a4144-developmc"
            }
        }
    }
};


export default awsmobile;
